import React from "react";
import { useApprovedReviews, useReviewStats } from "@/hooks/useQueryData";
import ReviewCard from "./ReviewCard";
import Button from "./ui/Button";
import { Link } from "react-router-dom";
import { ROUTES } from "@/config/constants";
import { FaStar } from "react-icons/fa";

const ReviewsSection: React.FC = () => {
  const { data: reviews = [], isLoading: loading, isError: error } = useApprovedReviews(6);
  const { data: stats } = useReviewStats();

  const hasReviews = reviews.length > 0;

  return (
    <section className="py-16 bg-gray-50 dark:bg-gray-950">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            What Our Clients Say
          </h2>

          {!loading && hasReviews && !error && stats && (
            <>
              <div className="flex items-center justify-center gap-2 mb-4">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={`text-2xl ${
                        i < Math.round(stats.averageRating) ? "text-yellow-400" : "text-gray-300"
                      }`}
                    />
                  ))}
                </div>
                <span className="text-xl font-semibold text-gray-900 dark:text-white">
                  {stats.averageRating.toFixed(1)} out of 5
                </span>
              </div>
              <p className="text-lg text-gray-600 dark:text-gray-400">
                Based on {stats.approved} verified review
                {stats.approved !== 1 ? "s" : ""}
              </p>
            </>
          )}

          {(loading || !hasReviews || error) && (
            <p className="text-lg text-gray-600 dark:text-gray-400 mt-4">
              {error
                ? "Reviews are being updated. Check back soon."
                : "Clients love working with WIH Media. Featured reviews are coming soon."}
            </p>
          )}
        </div>

        {loading && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 animate-pulse">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="h-40 rounded-xl bg-gray-200 dark:bg-gray-800" />
            ))}
          </div>
        )}

        {!loading && hasReviews && !error && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {reviews.map((review) => (
              <ReviewCard key={review.id} review={review} compact />
            ))}
          </div>
        )}

        <div className="text-center">
          <Link to={ROUTES.BOOKING}>
            <Button variant="primary" size="lg">
              Book a Session & Leave Your Review
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
